// extracted by mini-css-extract-plugin
export default {"root":"InlineButton_root__2UT-8","iconBefore":"InlineButton_iconBefore__fydZe","iconAfter":"InlineButton_iconAfter__w65kO","label":"InlineButton_label__7X021"};